import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CardWrapper from '../CardWrapper';
import WarningExclamationIcon from 'icons/WarningExclamation.icon';
import { Button } from 'ncoded-component-library';
import { BUSINESS_ROUTE } from 'data/global';
import { Link } from 'react-router-dom';
import useRequestAccess from '../../hooks/useRequestAccess';

import './ShareableLinkWithdrawnLead.styles.scss';

type ShareableLinkWithdrawnLeadProps = {
  className?: string;
  shareableLinkId: string;
  requestedAccessAt: Date;
};

const ShareableLinkWithdrawnLead: React.FC<ShareableLinkWithdrawnLeadProps> = (
  props,
) => {
  const { className, shareableLinkId, requestedAccessAt } = props;

  const classes = classNames('shareable-link-withdrawn-lead', className);

  const { t } = useTranslation();

  const {
    hasAlreadyRequestedAccess,
    hasRequestOrReminderSent,
    onSendReminder,
    onRequestAccess,
  } = useRequestAccess(shareableLinkId, requestedAccessAt);

  return (
    <div className={classes}>
      <CardWrapper title={t('accessSharedFiles')}>
        <div className="warning-banner">
          <div>
            <WarningExclamationIcon />
            <p>{t('withdrawnLeadWarningBannerTitle')}</p>
          </div>

          <p>{t('withdrawnLeadWarningBannerDescription')}</p>
        </div>

        <p>{t('wouldYouLikeToRequestAccess')}</p>

        <Button
          disabled={hasRequestOrReminderSent}
          onClick={hasAlreadyRequestedAccess ? onSendReminder : onRequestAccess}
        >
          {t('yesAddMeToTheWaitingRoom')}
        </Button>

        <Link to={BUSINESS_ROUTE}>{t('back')}</Link>
      </CardWrapper>
    </div>
  );
};

export default ShareableLinkWithdrawnLead;
